import { usePartnersProfileRetrieveSuspense } from "@boundless/bl-api-client/partners/services"
import { CopyIcon } from "lucide-react"
import { toast } from "sonner"

import { Card, CardHeader, CardTitle } from "@/components/ui/card"

export function ReferralLinkCard() {
  const { data: profile } = usePartnersProfileRetrieveSuspense()

  const origin = window.location.origin
  const partnerUrl = `${origin}/p/${profile.slug}/signup`

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(partnerUrl)
      toast.success("Referral Link copied to the clipboard!")
    } catch {
      toast.error("Error copying Referral link")
    }
  }

  return (
    <Card className="py-4">
      <CardHeader className="gap-3">
        <CardTitle>Referral Link</CardTitle>
        <button
          type="button"
          className="hover:text-primary flex w-full items-center gap-3 text-left"
          onClick={handleCopy}
        >
          <p className="min-w-0 flex-1 truncate text-sm lg:text-base">
            {partnerUrl}
          </p>
          <CopyIcon className="size-5 shrink-0" />
        </button>
      </CardHeader>
    </Card>
  )
}
